import { PredicateOperator } from './predicate-operator.enum';

export type Predicate<T> = {
    propertyName: string;
    operator: PredicateOperator;
    value: T;
};
